import React from 'react';
import Navbar from '../components/Navbar';
import Fleet from '../components/Fleet';
import Footer from '../components/Footer';

const FleetPage = () => {
  return (
    <div className="min-h-screen bg-black text-white font-sans selection:bg-yellow-500 selection:text-black">
      <Navbar />
      <Fleet />
      <Footer />
    </div>
  );
};

export default FleetPage;
